import styled from 'styled-components';

export const NewHireExceptionModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: -3%;
`;

export const NewHireExceptionModalHeaderTitle = styled.h3``;

export const NewHireExceptionModalBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: white;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 20px;
`;

export const NewHireExceptionModalForm = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 3%;
`;

export const NewHireExceptionModalFormNumber = styled.div`
  display: flex;
`;

export const NewHireExceptionModalLabel = styled.label`
  font-size: 13pt;
  margin-top: 7px;
  margin-bottom: 10px;
`;

export const NewHireExceptionModalDate = styled.input`
  height: 36px;
  font-size: 15px;
  border-radius: 5px;
  border: 0.5px black solid;
  padding: 5px;
`;

export const NewHireExceptionModalNumber = styled.input`
  width: 120px;
  border-radius: 10px;
  height: 36px;
  font-size: 15px;
  border-radius: 5px;
  border: 0.5px black solid;
  padding: 5px;
  margin-right: 15px;
`;

export const NewHireExceptionModalFooter = styled.div`
  display: flex;
  flex-direction: row-reverse;
  background-color: white;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  padding: 10px;
`;
